export default __webpack_public_path__ + "static/media/aml-headerlogo.3357bfe0.svg";